import React, {FC} from 'react'
import {Modal, Button, Form, Spinner, Alert} from 'react-bootstrap'

type ModalUploadTariffProps = {
  tariffType: string
  show: boolean
  onHide?: () => void
  onSubmit?: () => void
  onFileChange: (file: File | null) => void
  isLoading: boolean
  error: string | null
}

const ModalUploadTariff: FC<ModalUploadTariffProps> = ({
  tariffType,
  show,
  onHide,
  onSubmit,
  onFileChange,
  isLoading,
  error,
}) => {
  return (
    <Modal show={show} centered>
      <Modal.Header>
        <Modal.Title>Import New {tariffType} Data</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Please upload an Excel file to import <strong>{tariffType}</strong> data into the system</p>
        <Form.Group controlId='formFile'>
          <Form.Label>Upload File (.xlsx / .xls)</Form.Label>
          <Form.Control
            type='file'
            accept='.xlsx,.xls'
            onChange={(e) => {
              const target = e.target as HTMLInputElement
              const file = target.files?.[0] || null
              onFileChange(file)
            }}
            disabled={isLoading}
          />
        </Form.Group>
        {error && (
          <Alert variant='danger' className='mt-3'>
            {error}
          </Alert>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant='default' className='btn-cancel' onClick={onHide}>
          Cancel
        </Button>
        <Button variant='primary' onClick={onSubmit} disabled={isLoading}>
          {isLoading ? (
            <>
              <Spinner animation='border' size='sm' className='me-2' />
              Importing...
            </>
          ) : (
            'Import'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalUploadTariff
